import React, { useMemo } from 'react';
import { CommentLayout } from './CommentLayout';
import { INewComment } from './commentSchema';
import { CommentsTable } from './CommentsTable';
import { NewComment } from './NewComment';
import { useParams } from 'react-router-dom';
import { UUID } from '../../../types/shared/UUID';
import { checkForMutationSuccess } from '../../../API/checkForMutationSuccess';
import { convertToError } from '../../../API/BaseApi';
import { eCommentType, prettyCommentsType } from '../../../types/order/comment/eCommentType';
import { eCommentScope } from '../../../types/order/comment/eCommentScope';
import { vendorCommentTypes } from '../../../types/order/comment/VendorCommentTypes';
import { useCreateCommentMutation, useListCommentsQuery } from '../../../API/order/comments/CommentsApi';
import { ISelectOption } from '../../../ui-toolkit';

export const VendorCommentsContainer: React.FC = () => {
  const { orderId } = useParams<{ orderId: UUID }>();
  const { data: comments = [], error: queryError } = useListCommentsQuery({
    orderId,
    scope: eCommentScope.vendor,
  });
  const [createVendorComment, { error, isError, isLoading, isSuccess }] = useCreateCommentMutation();

  const onSubmit = async ({ content, type }: INewComment<eCommentType>) => {
    const response = await createVendorComment({
      orderId,
      content,
      type,
      scope: eCommentScope.vendor,
    });
    checkForMutationSuccess(response, 'Comment Created Successfully');
  };

  const options: ISelectOption<eCommentType>[] = useMemo(
    () =>
      vendorCommentTypes.map((type) => ({
        value: type,
        label: prettyCommentsType[type],
      })),
    []
  );

  return (
    <CommentLayout pageError={queryError}>
      <NewComment
        onSubmit={onSubmit}
        onSubmitFetchStatus={{ fetching: isLoading, success: isSuccess, fetched: isSuccess && !isError }}
        onSubmitFetchError={convertToError(error)}
        commentTypeOptions={options}
      />
      <CommentsTable comments={comments} />
    </CommentLayout>
  );
};
